module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAErCAYAAAAId3mkAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAABzSURBVGhD7cqhAYAwAMCwjU84j5PROwQMInIG15iazrXWMzbN+7y25+PrlmY1q1nNalazmtWsZjWrWc1qVrOa1axmNatZzWpWs5rVrGY1q1nNalazmtWsZjWrWc1qVrOa1axmNatZzWpWs5rVrGb9NY/xAmYUCF+03iPOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/error.png
// module id = 2148
// module chunks = 1